"use client";

import { createContext, useContext } from "react";
import type { PaginationLayout } from "./pagination";

export interface PaginationContextValue {
  layout: PaginationLayout;
  currentPage: number;
  totalPages?: number;
  hasNextPage?: boolean;
  onPageChange?: (page: number) => void;
}

export const PaginationContext = createContext<PaginationContextValue | null>(null);

export const usePagination = (): PaginationContextValue => {
  const ctx = useContext(PaginationContext);
  if (!ctx) throw new Error("Pagination parts must be used within <Pagination>.");
  return ctx;
};
